module.exports = new __parcel__URL__("c-question.73e7bfc7.svg").toString();